import { createSlice } from "@reduxjs/toolkit";
import {
  createUserApis,
  excelClientWiseReportCountApis,
  reportListsApis,
  testingListsApis,
  updatePasswordApis,
  userReportListsApis,
  usersApis,
} from "./testingActions";

const initialState = {
  userData: [],
  status: "idle",
  createStatus: "idle", // Added explicit initial state
  updatePasswordStatus: "idle", // Added explicit initial state
  error: null,
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    logout(state) {
      return initialState; // Reset to initial state on logout
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Users List
      .addCase(testingListsApis.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(testingListsApis.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.testingListsData = action.payload?.data || action.payload;
      })
      .addCase(testingListsApis.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
      })

  },
});

export const { logout } = usersSlice.actions;
export default usersSlice.reducer;
